/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI
 *
 * Copyright IBM Corp. 2017, 2019
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @file Controller to handle lasso related logic such as: lasso activation,
 * lasso co-oridinate provision etc.
 */

'use strict';

define([
	'../../../lib/@waca/core-client/js/core-client/ui/core/Events',
	'./LassoSelectView',
	'dashboard-analytics/DynamicFileLoader'
],function(Events, LassoSelectView, DynamicFileLoader) {

	var LassoController = Events.extend({

		/**
		 * @param {Object} options.targetElement element (jquery)
		 */
		init: function(options) {
			LassoController.inherited('init', this, arguments);
			this.targetElement = options.targetElement;
			this.cordinateResolver = options.cordinateResolver;
			this.isDragging =  options.isDragging;
			this._views = { [LassoController.DEFAULT_VIEW_ID]: { promise: Promise.resolve([LassoSelectView]), id: LassoController.DEFAULT_VIEW_ID } }; //Default view
			this.dashboard = options.dashboard;
			this._loadViewExts();
		},

		_loadViewExts:function(){
			this.dashboard && this.dashboard.getCollectionExtension('com.ibm.bi.dashboard.live-lassoView')
				.then(views => views.forEach(view => this._views[view.id] = { promise: DynamicFileLoader.load([view.class]), css: view.css, id: view.id  } ));
		},


		_loadCss(href) {
			const head = document.getElementsByTagName('head')[0];
			const stylesheet = head.querySelectorAll(`[href='${href}']`);
			if (!stylesheet.length) {
				const link  = document.createElement('link');
				link.rel  = 'stylesheet';
				link.type = 'text/css';
				link.href = href;
				link.media = 'all';
				head.appendChild(link);
			}
		},

		/**
		 * Activate/Deactivate lasso selection mode
		 * @param {boolean} [state=false] - state of lasso mode. True activates and
		 * false deactivates the lasso mode. Defaults to false.
		 */
		activateLassoMode: function(state, viewId){
			var _state = state || false;
			if(_state){
				const { promise, css, id } = this._views[viewId] || this._views[LassoController.DEFAULT_VIEW_ID];
				this.viewId = id;
				if(css){
					this._loadCss(css);
				}
				return promise
					.then(modules => {
						this.view = new modules[0](this.targetElement, this.cordinateResolver, this.isDragging);
						this.view.on('all', this._handleViewEvent, this);
					});
			}else if (this.isLassoMode()) {
				this.view.off('all', this._handleViewEvent, this);
				this.view.remove();
				this.view = null;
				this.viewId = '';
			}
			return Promise.resolve();
		},

		/**
		 * @return True if lasso mode is active, false otherwise.
		 */
		isLassoMode: function () {
			return !!this.viewId;
		},

		/**
		* Handler view event
		*/
		_handleViewEvent: function(payload, eventName){
			this.trigger(eventName, payload);
		},

		getCoordinates() {
			return this.view && this.view.getCoordinates();
		},

		getCurrentViewId(){
			return this.viewId;
		},

		remove: function(){
			this.activateLassoMode(false);
			LassoController.inherited('remove', this, arguments);
			this.targetElement = null;
		}
	});

	LassoController.DEFAULT_VIEW_ID = 'lw-lasso-select';

	return LassoController;
});
